import api from '../../../services/api'
import { StorageEnum } from '@/enums/storage'
import { Aluno } from '../../../domain/entities/aluno.entity'
import { IRegisterStudent, Response } from '../../../interfaces/types'

export class AlunoRepository {
  token = localStorage.getItem(StorageEnum.token)

  private static Instance: AlunoRepository = null
  public static GetInstance() {
    return !this.Instance
      ? (this.Instance = new AlunoRepository())
      : this.Instance
  }

  async list(
    token: string,
    params: { page: number; perPage: number },
  ): Promise<Response<Aluno>> {
    const headers = { Authorization: `Bearer ${token}` }

    const { data } = await api.get<{ students: Response<Aluno> }>(
      '/admin/students',
      {
        headers,
        params,
      },
    )

    return data.students
  }

  async findById(token: string): Promise<Aluno> {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.get('/students/consultar', {
      headers,
    })

    return response.data as Aluno
  }

  async adminFindById(id: string) {
    const headers = { Authorization: `Bearer ${this.token}` }
    const response = await api.get('/admin/students/registrations/' + id, {
      headers,
    })

    return response
  }

  async findByProperty({
    page,
    perPage,
    property,
    token,
    value,
  }: {
    token: string
    property: string
    value: string
    page: number
    perPage: number
  }) {
    const headers = { Authorization: `Bearer ${token}` }
    const url = `/admin/students/by-property?property=${property}&value=${value}&page=${page}&perPage=${perPage}`
    const response = await api.get(url, { headers })
    return response.data
  }

  async register(cadastro: IRegisterStudent) {
    const response = await api.post('/students', cadastro)
    return response
  }

  async documentos(token: string) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.get('/students/documentos', {
      headers,
    })

    return response.data
  }

  async adminListDocuments(token: string, student_id: string) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.get(`/admin/students/documents/${student_id}`, {
      headers,
    })

    return response.data.documents
  }

  async adminDeleteDocumento(token: string, document_id: string) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.delete(
      `/admin/students/documents/delete/${document_id}`,
      {
        headers,
      },
    )

    return response.data.documento
  }

  async adminAddDocument(aluno_id: string, file: File, type: string) {
    const formData = new FormData()
    formData.append('document', file)

    const headers = {
      Authorization: `Bearer ${this.token}`,
      'Content-Type': 'Application/pdf',
    }

    const response = await api.post(
      `/admin/students/documents/${aluno_id}/${type}`,
      formData,
      { headers },
    )

    return response.data
  }

  async atualizar(data: Aluno) {
    const headers = {
      Authorization: `Bearer ${this.token}`,
    }

    const response = await api.put(
      `/students/${data.id}`,
      { data },
      {
        headers,
      },
    )

    return response.data
  }
}
